import { VendorMetadataBlock } from "./VendorMetadataBlock";

export function VendorMetadataEMVBlock() {
  return (
    <VendorMetadataBlock 
      blockSettings={{ 
        metadataType: "EMV",
        useMonospace: true 
      }} 
    />
  );
}
